import { css } from '@emotion/react';
import { FloatingPortal } from '@floating-ui/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { SpinningLoader, Truncated } from '@frontend/design-system';
import { useAnalyticsReportingShallowStore } from '../hooks/use-analytics-reporting-store';

export const FloatingStatus = () => {
  const { t } = useTranslation('analytics-reporting');
  const { downloadStatus, fileName } = useAnalyticsReportingShallowStore('downloadStatus', 'fileName');

  if (!downloadStatus?.isPreparingDownload || typeof downloadStatus?.isPreparingDownload !== 'boolean') {
    return null;
  }

  return (
    <FloatingPortal>
      <div css={styles.wrapper}>
        <SpinningLoader size='medium' />
        <div css={styles.content}>
          <Truncated className='main-text'>{fileName}</Truncated>
          <Truncated className='sub-text'>{t('Preparing your download...')}</Truncated>
        </div>
      </div>
    </FloatingPortal>
  );
};

const styles = {
  wrapper: css`
    align-items: center;
    background-color: ${theme.colors.white};
    border-radius: ${theme.borderRadius.medium};
    bottom: ${theme.spacing(4)};
    box-shadow: ${theme.shadows.heavy};
    display: flex;
    gap: ${theme.spacing(1)};
    max-width: 324px;
    overflow: hidden;
    padding: ${theme.spacing(2)};
    position: fixed;
    right: ${theme.spacing(4)};
    width: 100%;
  `,

  content: css`
    .main-text {
      font-weight: ${theme.font.size.medium};
      max-width: 240px;
    }

    .sub-text {
      color: ${theme.font.colors.subdued};
      font-size: ${theme.font.size.small};
      max-width: 240px;
    }
  `,
};
